<template>
  <apexchart type="line" :options="humidChart" :series="humidSeries" :height="height" :width="width"></apexchart>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";

Vue.component("apexchart", VueApexCharts);

export default {
  props: {
    humidSeries: Array,
    height: Number,
    width: Number,
  },
  data() {
    return {
      humidChart: {
        chart: {
          id: "humidity",
          group: "smp",
          type: "line",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          tooltip: {
            enabled: false,
          },
          type: "datetime",
          labels: {
            datetimeUTC: false,
            style: {
              fontSize: "12px",
              colors: "primary",
            },
          },
        },

        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
          theme: true,
        },
        legend: {
          show: false,
          showForSingleSeries: true,
          position: "bottom",
          labels: {
            colors: "primary",
          },
        },
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 5,
          axisTicks: {
            show: true,
          },
          labels: {
            offsetX: -17,
            style: {
              fontSize: "12px",
              colors: "primary",
            },
            formatter: (val) => {
              return val.toFixed(2) + " %RH";
            },
          },
        },
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
      },
    };
  },
};
</script>